document.addEventListener("DOMContentLoaded", (event) => {
  let atcButton = document.querySelector("#ProductSubmitButton-sticky-atc");
  if(atcButton){
    atcButton.addEventListener("click", function(e){
      setTimeout(function(){
        document.querySelector("product-form form button[type='submit']").click();
      },100)
    });
  }
});

window.applySwiperToCartDrawer = function(){
  if( document.querySelectorAll('cart-drawer #CartDrawer .swiper-container div.swiper-slide').length > 1 ){
    new Swiper('cart-drawer #CartDrawer .swiper-container', {
      loop: true,
      slidesPerView: 1,
      paginationClickable: true,
      spaceBetween: 20,
      navigation: {
        nextEl: "cart-drawer #CartDrawer .swiper-button-next",
        prevEl: "cart-drawer #CartDrawer .swiper-button-prev",
      },
      pagination: {
        el: '.slider__pagination',
        clickable: true,
      }
    });
  }
}

document.addEventListener("DOMContentLoaded", (event) => {
  if(window.innerWidth < 1200){
    let targetNode = document.querySelector(".product__value--proposition-grid");
    
    if (targetNode) {
      let insertAfterNode = document.querySelector(".product__media-sublist--wrap");
    
      if (insertAfterNode) {
        // Using parentNode.insertBefore to achieve the "insert after" behavior
        insertAfterNode.parentNode.insertBefore(
          targetNode,
          insertAfterNode.prevSibling
        );
      }
    }

  }
  console.log("DOM fully loaded and parsed");
});